<template>
  <v-row>
    <v-col cols="6" md="4">
      <custom-label title="Placa" :value="vehicle.plate"/>
      <custom-label title="Categoria do veículo" :value="product_body.category.name"/>
    </v-col>
    <v-col cols="6" md="4">
      <custom-label title="Tipo de estacionamento" :value="product_body.group.name"/>
      <custom-label title="Tempo" :value="`${product_body.product.time} min`"/>
      <custom-label title="Valor" :value="`R$ ${formatMoney(product_body.product.price)}`"/>
    </v-col>
    <v-col cols="12" v-if="messages.length > 0">
      <v-alert type="error" color="#e72c1f" v-for="(message) in messages" :key="message">
        {{ message }}
      </v-alert>
    </v-col>
  </v-row>
</template>

<script>

import CustomLabel from "@/components/Label.vue";

export default {
  name: "Confirm",
  components: {
    CustomLabel
  },
  props: {
    product_body: {
      type: Object,
    },
    vehicle: {
      type: Object,
    },
    messages: {
      type: Array,
    },
  },
}
</script>

<style scoped>
</style>
